<!-- 搜车用品 -->
<template>
    <div class="business-content-main goodSearch" id="goodSearch">
        <div class="bread-nav">
            <div>您当前位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>客服</el-breadcrumb-item>
                <el-breadcrumb-item>汽配快搜</el-breadcrumb-item>
                <el-breadcrumb-item>搜商城商品</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-name">商品编码:</div>
            <el-input
                    style="width: 200px"
                    class="search-item"
                    size="small"
                    v-model="searchData.GoodsCode"
                    placeholder="请输入商品编码">
            </el-input>
            <div class="search-name">商品名称:</div>
            <el-input
                    class="search-item"
                    size="small"
                    v-model="searchData.Keyword"
                    placeholder="请输入商品名称">

            </el-input>
            <el-button type="primary" size="small" icon="el-icon-search" class="search-btn " @click="handleSearch">查询</el-button>
            <el-button type="primary" size="small" icon="el-icon-refresh" class="search-btn " @click="resetSearch">重置</el-button>
        </div>
        <div class="qp-ctn" v-if="tableDataLength != 0">
            <el-card class="box-card qp-item" v-for="item in tableData" :key="item.Id">
                <div @click="gotoDetails(item.Id)">
                    <div class="qp-cover">
                        <img :src="downloadUrl+item.ShowImg" alt="" :onerror="defaultImg">
                        <div class="goods-activity" v-if="item.IsNew == 1 || item.IsBest == 1 ||item.IsHot == 1">
                            <div>
                                <div class="type-icon" v-if="item.IsNew == 1">新品</div>
                                <div class="type-icon" v-if="item.IsBest == 1">精品</div>
                                <div class="type-icon" v-if="item.IsHot == 1">热门</div>
                            </div>
                        </div>
                    </div>
                    <div class="qp-msg">
                        <div class="qp-dir">
                            <p><span class="goods-money">￥{{item.ShopPrice}}</span></p>
                        </div>
                        <p class="qp-name" :title="item.Name">{{item.Name}}</p>
                        <p>编码:{{item.GoodsCode}}</p>
                    </div>
                    <p class="ops-ctn">
                        <el-button size="mini" @click.stop="pushGoods(item)">推送</el-button>
                    </p>
                </div>
            </el-card>
        </div>
        <div v-else class="no-data">
            无搜索结果
        </div>
        <div class="pagination-ctn">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[12, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength">
            </el-pagination>
        </div>
        <el-dialog
                title="推送"
                :visible.sync="dialogVisible"
                width="800px"
        >   <div class="dialog-content">
            <!-- 推送商品 -->
            <template>
                <push @closeDialog="closeDialog" ref="push" :goodMsg="choosedGood"></push>
            </template>
        </div>
        </el-dialog>
    </div>
</template>
<script>
    import push from '@/components/business/search/pushShopGoods.vue'
    export default {
        name: 'goodSearch',
        components: {
            push
        },
        data() {
            return {
                choosedGood:[],
                goodsType:'',
                dialogVisible:false,
                categoriesShow:false,
                defaultImg:'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
                downloadUrl:this.$util.QN_URL_BASE,
                tableData: [],
                tableDataLength:0,
                options: [],
                searchData: {
                    GoodsCode:'',
                    Keyword:'',
                    CategoryId:'',
                    page:1,
                    limit:12,
                },
                currentPage:1, // 当前页
                balls: [ //小球 设为3个
                    {
                        show: false
                    },
                    {
                        show: false
                    },
                    {
                        show: false
                    },
                    {
                        show: false
                    },
                    {
                        show: false
                    },
                ],
                dropBalls: [],
                permission:{}
            }
        },
        mounted() {
            window.onclick = ()=>{
                this.categoriesShow = false
            }
            let _AutoSerieId = this.$route.query.AutoSerieId
            if (_AutoSerieId){
                this.searchData.CategoryId = _AutoSerieId
            }
            this.getTableData()
            this.$util.getPermission('搜索商城商品').then((res)=>{
                this.permission = res
            })
        },
        methods: {
            closeDialog(){
                this.dialogVisible = false
            },
            pushGoods(item){
                if (item){
                    this.choosedGood = item
                }
                if (this.$store.state.connectState != 2){
                    this.$message({
                        message: '请先连接到客服并接入客户',
                        type: 'warning'
                    });
                    return
                }
                this.dialogVisible = true
            },
            // 重置表单
            resetSearch(){
                this.goodsType = ''
                this.searchData = {
                    entpId:this.$util.getSessionStorage('EntpId'),
                    GoodCode:'',
                    Keyword:'',
                    CategoryId:'',
                    page:1,
                    limit:10,
                }
            },
            // 选中商品分类
            chooseNode(data){
                if (data){
                    this.goodsType = data.Category.CategoryName
                    this.searchData.CategoryId = data.Category.CategoryNumber
                }
                else {
                    this.goodsType = ''
                    this.searchData.CategoryId = ''
                }
                this.categoriesShow = false
            },
            // 显示树
            showCategories(){
                this.categoriesShow = true
            },
            // 跳转结算页
            gotoOrderInfo(id){
                this.$router.push(`/business/shop/getOrderInfo?GoodsId=${id}&GoodsType=5&GoodsTypeId=${id}`)
            },
            // 跳转到汽配详情
            gotoDetails(id){
                this.$router.push(`./goodsDetail?id=${id}`)
            },
            // 获取数据
            getTableData(){
                this.$util.axiosGet({
                    url:'/search/Search/MallVehicleGoodsSearch',
                    data:this.searchData,
                    search:true,
                }).then((res)=>{
                    let data =res.data
                    this.tableData = data
                    this.tableDataLength = res.count
                })
            },
            handleSearch(){
                this.searchData.page = 1
                this.getTableData()
            },
            handleSizeChange(val) {
                this.searchData.limit = val
                this.getTableData()
            },
            handleCurrentChange(val) {
                this.searchData.page = val
                this.getTableData()
            },
        }
    }
</script>
<style lang="less" scoped>
    .qp-name,.goods-name {
        padding-bottom: 0;
        flex-shrink: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        font-size: 14px;
        line-height: 1.5em;
        -webkit-box-orient: vertical;
        margin:10px 0;
        cursor: pointer;
        min-height: 42px;
        //&:hover{
        //  color: @theme;
        //}
    }
    .ops-ctn {
        justify-content: flex-end !important;
        padding-right: 20px!important;
    }
    .qp-cover {
        position: relative;
    }
    .goods-money {
        color: red;
        font-size: @font-md;
    }
    .no-inventory {
        color: red;
        line-height: 24px;
        padding: 10px 0;
    }
    .ball {
        position: fixed;
        left: 32px;
        bottom: 22px;
        z-index: 200;
        transition: all 0.4s cubic-bezier(0.49, -0.29, 0.75, 0.41);
        /*贝塞尔曲线*/
    }
    .inner {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background-color: rgb(0, 160, 220);
        transition: all 0.4s linear;
    }

    .goodSearch {
        padding-right: 52px;
    }
    .goods-categories {
        position: relative;
    }
    .qp-ctn {
        display: flex;
        flex-wrap: wrap;
    }
    .qp-item {
        cursor: pointer;
        width: 250px;
        margin-right: 20px;
        margin-bottom: 20px;
    }
    .ops-ctn {
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
    }
    .categories-tree {
        position: absolute;
        background: white;
        bottom: 0;
        left: 0;
        width: 100%;
        transform: translate(0,100%);
        border: 1px solid @border3Color;
        border-radius: 10px;
        z-index: 1;
        overflow-x: hidden;
    }
    .qp-cover {
        width: 263px !important;
        height: 230px !important;
        img{
            max-width: 263px !important;
            max-height: 230px !important;
        }
    }
</style>
<style lang="less">
    .goodSearch {
        .el-card__body {
            padding: 0;
        }
    }
</style>
